import space from '@styled-system/space'
import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import ButtonRoundedSt from 'components/ButtonRoundedSt'
import DiscountLabel from 'components/DiscountLabel'
import DynamicImage from 'components/DynamicImage'
import { Col, RowIndented } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

export const RowStyled = styled(RowIndented)`
  position: relative;
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};
  background: ${p => p.theme.colors.grayOp06NonTransp};
  border-bottom: 1px solid ${p => p.theme.colors.blackOp06};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
    padding-bottom: ${em(30)};
    flex-wrap: nowrap;
    min-height: ${em(175)};
    border-radius: ${em(10)};
    margin-bottom: ${em(20)};
    border-bottom: none;
    margin-left: 0;
    margin-right: 0;
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(20)};
    padding-bottom: ${em(20)};
    min-height: ${em(180)};
    margin-left: -${p => math(`${p.theme.indents.baseIndentMd}/2`)};
    margin-right: -${p => math(`${p.theme.indents.baseIndentMd}/2`)};
  }
`

export const ColStyled = styled(Col)`
  ${space};
`

export const ItemTitle = styled.h5`
  display: inline-block;
  font-size: ${p => p.theme.typography.fontSize};
  line-height: ${p => p.theme.typography.cartFontLh};
  font-weight: 400;

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.h3};
    line-height: ${p => p.theme.typography.h3Lh};
  }

  ${p => p.theme.mq.upLg} {
    font-size: ${p => p.theme.typography.textCartSubtitle};
    line-height: ${p => p.theme.typography.textCartSubtitleLh};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: relative;
  top: ${em(7)};
  width: ${em(55)};
  height: auto;

  ${p => p.theme.mq.upMd} {
    top: ${em(8)};
    display: inline-block;
    width: ${em(80)};
  }

  ${p => p.theme.mq.upLg} {
    top: 0;
    display: block;
    width: ${em(130)};
  }
`

export const ButtonRoundedStStyled = styled(ButtonRoundedSt)`
  display: block;
  width: auto;
  flex-shrink: 0;

  span {
    white-space: nowrap;
  }

  ${p => p.theme.mq.upMd} {
    width: ${em(137)};
  }
`

export const Title = styled.div`
  max-width: ${em(270)};

  ${p => p.theme.mq.upLg} {
    max-width: ${em(280)};
  }
`

export const TextLHStyled = styled(TextLH)`
  display: block;
  font-size: ${p => p.theme.typography.cartFontSize};
  line-height: ${p => p.theme.typography.cartFontLh};

  ${p => p.theme.mq.upMd} {
    line-height: 2.5;
  }
`

export const ButtonContent = styled.div`
  padding: ${em(8)} ${em(35)} ${em(10)};
  display: flex;
  align-items: center;
  justify-content: center;

  ${p =>
    p.isZeroPrice &&
    css`
      ${p => p.theme.mq.upMd} {
        padding-left: 0!important;
        padding-right: 0!important;
      }
    `}

  ${p =>
    !p.isZeroPrice &&
    css`
      ${p => p.theme.mq.upMd} {
        padding: 0 ${em(25)};
      }
    `}
`

export const TextCartEmpty = styled.span`
  display: block;
  color: ${p => p.theme.colors.blackOp4};
  line-height: 1.375;
  margin-top: ${em(6)};

  ${p => p.theme.mq.upMd} {
    color: ${p => p.theme.colors.black};
    line-height: 1.625;
    max-width: ${em(335)};
    margin-top: ${em(12)};
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(250)};
    margin-top: 0;
  }
`

export const DiscountLabelStyled = styled(DiscountLabel)`
  display: inline;
  line-height: 2;
  font-size: ${p => p.theme.typography.textSmallDescr};
  font-family: ${p => p.theme.typography.mediumFont};
  font-weight: 400;
  margin-left: ${p => em(5, p.theme.typography.textSmallDescrPx)};
  padding-left: ${p => em(4, p.theme.typography.textSmallDescrPx)};
  padding-right: ${p => em(4, p.theme.typography.textSmallDescrPx)};
  padding-top: 0;
  padding-bottom: ${p => em(2, p.theme.typography.textSmallDescrPx)};
  top: -${em(1)};

  ${p => p.theme.mq.upMd} {
    position: relative;
    top: -${em(2)};
    line-height: 2.3;
    padding-top: ${p => em(2, p.theme.typography.textSmallDescrPx)};
    padding-bottom: ${p => em(4, p.theme.typography.textSmallDescrPx)};
    margin-left: ${p => em(15, p.theme.typography.textSmallDescrPx)};
  }

  ${p => p.theme.mq.upLg} {
    top: -${em(3)};
    line-height: 3.3;
  }
`

export const CostBlock = styled.div`
  line-height: 0;
`
